module.exports = __webpack_public_path__ + "static/img/youtobe_grid.2a17a152.png";